import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosConfig";
import "./ClubRequests.css";
import { Link } from "react-router-dom";

function ClubRequests() {
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState("");
  const [decisions, setDecisions] = useState({}); // Store selected decisions for each request

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await axiosInstance.get("/myclub/requests/");
        setRequests(response.data.requests);
      } catch (error) {
        setError("Failed to fetch requests.");
      }
    };

    fetchRequests();
  }, []);

  const handleDecisionChange = (requestId, decision) => {
    setDecisions((prevDecisions) => ({
      ...prevDecisions,
      [requestId]: decision,
    }));
  };

  const handleSubmit = async (requestId) => {
    const decision = decisions[requestId];
    if (!decision) {
      alert("Please select a decision before submitting.");
      return;
    }

    try {
      const response = await axiosInstance.post("/myclub/decision/", {
        request_id: requestId,
        decision,
      });
      alert(response.data.message);
      setRequests((prevRequests) =>
        prevRequests.map((req) =>
          req.id === requestId ? { ...req, status: decision } : req
        )
      );
      setDecisions((prevDecisions) => {
        const updated = { ...prevDecisions };
        delete updated[requestId];
        return updated;
      });
    } catch (error) {
      alert("Failed to process the request.");
    }
  };

  if (error) return <p>{error}</p>;

  return (
    <div className="club-requests-container">
      {/* Header */}
      <h1 className="club-requests-header">Club Requests</h1>

      {/* Mobile Card Layout */}
      <div className="mobile-requests-container">
        {requests.length === 0 ? (
          <p className="no-requests-message">Contact information requests from clubs will appear here.</p>
        ) : (
          requests.map((request) => (
            <div key={request.id} className="request-card">
              <div className="card-row">
                <span className="card-label">Club Name:</span>
                <Link
                  to={request.status === "pending" ? `/club/${request.id}` : "#"}
                  className="card-value clickable"
                >
                  {request.club_name}
                </Link>
              </div>
              <div className="card-row">
                <span className="card-label">Status:</span>
                <span className="card-value">{request.status}</span>
              </div>
              {request.status === "pending" && (
                <>
                  <div className="radio-actions">
                    <label>
                      <input
                        type="radio"
                        name={`decision-${request.id}`}
                        value="approve"
                        checked={decisions[request.id] === "approve"}
                        onChange={() =>
                          handleDecisionChange(request.id, "approve")
                        }
                      />
                      Approve
                    </label>
                    <label>
                      <input
                        type="radio"
                        name={`decision-${request.id}`}
                        value="deny"
                        checked={decisions[request.id] === "deny"}
                        onChange={() => handleDecisionChange(request.id, "deny")}
                      />
                      Deny
                    </label>
                  </div>
                  <button
                    className="submit-button"
                    onClick={() => handleSubmit(request.id)}
                  >
                    Submit
                  </button>
                </>
              )}
            </div>
          ))
        )}
      </div>

      {/* Table Layout for Larger Screens */}
      {requests.length > 0 && (
        <table className="requests-table">
          <thead>
            <tr>
              <th>Club Name</th>
              <th>Status</th>
              <th>Action</th>
              <th>Submit</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.id}>
                <td>
                  <Link
                    to={request.status === "pending" ? `/club/${request.id}` : "#"}
                    className="clickable"
                  >
                    {request.club_name}
                  </Link>
                </td>
                <td>{request.status}</td>
                <td>
                  {request.status === "pending" && (
                    <div className="radio-actions">
                      <label>
                        <input
                          type="radio"
                          name={`decision-${request.id}`}
                          value="approve"
                          checked={decisions[request.id] === "approve"}
                          onChange={() =>
                            handleDecisionChange(request.id, "approve")
                          }
                        />
                        Approve
                      </label>
                      <label>
                        <input
                          type="radio"
                          name={`decision-${request.id}`}
                          value="deny"
                          checked={decisions[request.id] === "deny"}
                          onChange={() =>
                            handleDecisionChange(request.id, "deny")
                          }
                        />
                        Deny
                      </label>
                    </div>
                  )}
                </td>
                <td>
                  {request.status === "pending" && (
                    <button
                      className="submit-button"
                      onClick={() => handleSubmit(request.id)}
                    >
                      Submit
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ClubRequests;
